import { render, staticRenderFns } from "./foodList.vue?vue&type=template&id=20a8bf86&scoped=true"
import script from "./foodList.vue?vue&type=script&lang=js"
export * from "./foodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8bf86",
  null
  
)

export default component.exports